export default __webpack_public_path__ + "static/media/open_up.b962ee30.mp3";